var a={getAdditionalColorsLabel:function(a){return"".concat(a," additional colors available")},label:"Available colors"};export{a as colorSelectionTranslations};
